import {
  type PermissionRouteGuardData,
  PermissionRouteGuard,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useQuestionCreationTaskDetails } from '@exam-management/question-creation-task-details';
import { Navigate, useParams } from '@exam-management/router';
import { QuestionCreationWorkflowStepCodeObject } from '@exam-management/task-management';
import { Outlet } from 'react-router-dom';

export default function QuestionCreationTaskQuestionManagementLayout() {
  const { taskId } = useParams('/task-management/question-creation/:taskId');
  const { status } = useQuestionCreationTaskDetails();

  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/task-management/question-creation/:taskId/single/create',
      requiredPermission: [APP_PERMISSIONS.TASK.QUESTION_CREATION.CREATE],
      params: {
        taskId,
      },
    },
  ];
  // TODO: Just workaround to protected user who want to access create question page when task status is not in progress
  if (status.code !== QuestionCreationWorkflowStepCodeObject.QuestionCreationInProgress) {
    return <Navigate to='/access-denied' replace />;
  }

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <Outlet />
    </PermissionRouteGuard>
  );
}
